/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} LogoutInputs */

const en_logout = /** @type {(inputs: LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logout`)
};

const fr_logout = /** @type {(inputs: LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déconnexion`)
};

const de_logout = /** @type {(inputs: LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abmelden`)
};

const it_logout = /** @type {(inputs: LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esci`)
};

const ru_logout = /** @type {(inputs: LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выйти`)
};

const es_logout = /** @type {(inputs: LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar sesión`)
};

const zh_cn2_logout = /** @type {(inputs: LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注销`)
};

const ja_logout = /** @type {(inputs: LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ログアウト`)
};

const hi_logout = /** @type {(inputs: LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लॉग आउट`)
};

const pt_pt2_logout = /** @type {(inputs: LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sair`)
};

/**
* | output |
* | --- |
* | "Logout" |
*
* @param {LogoutInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const logout = /** @type {((inputs?: LogoutInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<LogoutInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_logout(inputs)
	if (locale === "de") return de_logout(inputs)
	if (locale === "it") return it_logout(inputs)
	if (locale === "ru") return ru_logout(inputs)
	if (locale === "es") return es_logout(inputs)
	if (locale === "zh-CN") return zh_cn2_logout(inputs)
	if (locale === "ja") return ja_logout(inputs)
	if (locale === "hi") return hi_logout(inputs)
	if (locale === "pt-PT") return pt_pt2_logout(inputs)
	return en_logout(inputs)
});